var installedModules = {};
var moduleToHandlerMapping = {
	4854: {
		getter: () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.0.2",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["modern"],
		},
		shareKey: "react",
	},
	54663: {
		getter: () => (__webpack_require__.e(2026).then(() => (() => (__webpack_require__(42026))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^0.4.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "reflux",
	},
	97598: {
		getter: () => (__webpack_require__.e(961).then(() => (() => (__webpack_require__(40961))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.0.2",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["modern"],
		},
		shareKey: "react-dom",
	},
	38815: {
		getter: () => (__webpack_require__.e(4179).then(() => (() => (__webpack_require__(24179))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.2.6",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router",
	},
	56901: {
		getter: () => (__webpack_require__.e(1370).then(() => (() => (__webpack_require__(28989))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^0.23.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router-bootstrap",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"1295": [
		56901
	],
	"4854": [
		4854
	],
	"5198": [
		97598
	],
	"6428": [
		56901
	],
	"8815": [
		38815
	],
	"9030": [
		54663
	],
	"9874": [
		56901
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}